import Accordion from '@components/Accordion';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ENCOFFEE_PROJECT_IDS } from '@constants/projects';
import styled from '@emotion/styled';
import useProjectId from '@hooks/useProjectId';

import { ENCOFFEE_PREPAID_CARD_NOTES, PREPAID_CARD_NOTES, PrepaidCardNoteType } from './notes';

interface Props {
    types?: PrepaidCardNoteType[];
    noMargin?: boolean;
}

function PrepaidCardNotes({ types = ['USAGE', 'REFUND'], noMargin }: Props) {
    const notes = ENCOFFEE_PROJECT_IDS.includes(useProjectId()) ? ENCOFFEE_PREPAID_CARD_NOTES : PREPAID_CARD_NOTES;

    return (
        <Container noMargin={noMargin}>
            {types.map((type) => notes[type]).map(({ title, items }) => (
                <Accordion key={title}
                    initialOpen
                    title={<Text size='body-short' fontWeight='medium' color={colors.textSecondary}>{title}</Text>}>
                    <List>
                        {items.map((item) => (
                            <li key={item}>
                                <Text size='body-long' color={colors.textSecondary} multiline>
                                    {item}
                                </Text>
                            </li>
                        ))}
                    </List>
                </Accordion>
            ))}
        </Container>
    );
}

const Container = styled('footer', {
    shouldForwardProp: (prop) => prop !== 'noMargin',
})<{
    noMargin?: boolean;
}>`
    margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '48px')};
    width: 100%;
`;

const List = styled.ol`
    color: var(--color-text-secondary);
    font-size: var(--font-size-body-long);
    list-style: decimal;
    margin: 0;
    padding-left: var(--spacing-4);
`;

export default PrepaidCardNotes;
